import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import Image from './Image'

import { stickyIt } from '~styles/utility'

const StylesPersonCalloutVariables = {
  media: 100,
}

const PersonCallout = ({ media, name, position, children, ...rest }) => {
  const theme = useTheme()

  return (
    <div
      css={{
        marginTop: theme.space.large,
        marginBottom: theme.space.large,
        display: 'grid',
        justifyContent: 'center',
        gap: theme.space.base,

        [theme.mq.medium]: {
          gridTemplateColumns: `${StylesPersonCalloutVariables.media}px 1fr`,
        },
      }}
      {...rest}
    >
      <div>
        <Image
          src={media}
          alt={name}
          css={{
            objectFit: 'cover',
            width: StylesPersonCalloutVariables.media,
            height: StylesPersonCalloutVariables.media,
            borderRadius: theme.borderRadius.rounded,

            [theme.mq.medium]: [stickyIt(theme)],
          }}
        />
      </div>
      <div css={{ marginBottom: theme.space.base }}>
        <h4 css={{ fontSize: theme.fontSize.xlarge, margin: 0 }}>{name}</h4>
        <div
          css={{ fontSize: theme.fontSize.small, color: theme.fontColor.muted }}
        >
          {position}
        </div>
        {children}
      </div>
    </div>
  )
}

PersonCallout.propTypes = {
  media: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default PersonCallout
